module.exports = "/fonts/Arial.woff?75400f069595b41e88ac700507811970";